import { isEmail } from '@pperform/pp-utils/validation';

export default (key: string, value: string): string => {
  const required = value !== '' ? '' : 'REQUIRED_FIELD';
  const email = isEmail(value) ? '' : 'INVALID_EMAIL';

  if (required) {
    return required;
  }

  const searchFieldValidation = {
    'to_address.email': email,
    'from_address.email': email,
  };

  return key in searchFieldValidation ? searchFieldValidation[key] : '';
};
